import { render, staticRenderFns } from "./ImportCard.vue?vue&type=template&id=32a3294a&scoped=true"
import script from "./ImportCard.vue?vue&type=script&lang=js"
export * from "./ImportCard.vue?vue&type=script&lang=js"
import style0 from "./ImportCard.vue?vue&type=style&index=0&id=32a3294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3294a",
  null
  
)

export default component.exports